import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import moIndex from '../store';
import HeadPdf from '../component/head-pdf';
import Title from '../component/title';
import FootPdf from '../component/foot-pdf';
import Pdf from '../component/pdf';
import './scss/company-rank.scss';
import CompanyRankChart from './component/company-rank-chart';
import moDemandPdf from './store';
import { cloneDeep, isEmpty } from 'lodash';
import { getTableList } from '../store/common';

interface IProps {}
interface IState {}

const ComapnyRank = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { companyRankList } = moDemandPdf;

  const getResult = useMemo(() => {
    let list: any = [];
    if (!isEmpty(companyRankList?.data)) {
      const res = cloneDeep(companyRankList?.data);
      res.sort((a: any, b: any) => b.amount_change - a.amount_change);
      list = res || [];
    }
    return !isEmpty(list) ? getTableList(list, 7) : [];
  }, [companyRankList]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section>
      {getResult.map((res: any, r: any) => {
        return (
          <section key={r}>
            <Pdf>
              <section className="company-rank-pdf-warp">
                <HeadPdf onetitle="人力资源核心指标" twotitle={moIndex.industry.name} />
                <section className="company-rank-top-title">
                  <Title
                    title="招聘动态 - 典型公司"
                    bigTitle="人力需求"
                    tag="TOP100"/>
                  <CompanyRankChart list={res} index={r}/>
                  {r === 0 && <span className="tags">当期招聘量</span>}
                </section>
                <FootPdf />
              </section>
            </Pdf>
          </section>
        );
      })}
    </section>
  );
};

export default observer(ComapnyRank);
